export default __webpack_public_path__ + "static/media/68.54a21942.jpg";